export default __webpack_public_path__ + "static/media/social_S.b95e8370.png";